<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-xl-2">
            <label>{{ 'FROM_MONTH' | translate }}</label>
            <ng-select [searchable]="false" [openOnEnter]="true" [closeOnSelect]="true" [clearable]="false" [(ngModel)]="filterMonthFrom">
              <ng-option *ngFor="let month of monthsList; let i = index" [value]="i + 1">{{ month }}</ng-option>
            </ng-select>
          </div>
          <div class="col-xl-2 pr-0">
            <label>{{ 'FROM_YEAR' | translate }}</label>
            <ng-select [searchable]="false" [openOnEnter]="true" [closeOnSelect]="true" [clearable]="false" [(ngModel)]="filterYearFrom">
              <ng-option *ngFor="let y of yearsList; let i = index" [value]="y">{{ y }}</ng-option>
            </ng-select>
          </div>
          <div class="col-xl-2 border-left ml-2 pl-2">
            <label>{{ 'TO_MONTH' | translate }}</label>
            <ng-select [searchable]="false" [openOnEnter]="true" [closeOnSelect]="true" [clearable]="false" [(ngModel)]="filterMonthTo">
              <ng-option *ngFor="let month of monthsList; let i = index" [value]="i + 1">{{ month }}</ng-option>
            </ng-select>
          </div>
          <div class="col-xl-2">
            <label>{{ 'TO_YEAR' | translate }}</label>
            <ng-select [searchable]="false" [openOnEnter]="true" [closeOnSelect]="true" [clearable]="false" [(ngModel)]="filterYearTo">
              <ng-option *ngFor="let y of yearsList; let i = index" [value]="y">{{ y }}</ng-option>
            </ng-select>
          </div>
          <div class="col text-right pt-05">
            <button type="button" class="btn btn-outline-primary mt-1" (click)="loadBalance(true)">{{ 'FILTER' | translate }}</button>
            <button type="button" class="btn btn-primary mt-1 mx-2" (click)="export()" [ngbTooltip]="'EXPORT_EXCEL' | translate">{{ 'EXPORT' | translate }}</button>
            <button type="button" class="btn btn-outline-primary mt-1" *ngIf="!showChart" (click)="showChart = true">{{ 'COMMISSIONS.SHOW_CHART' | translate }}</button>
            <button type="button" class="btn btn-outline-primary mt-1" *ngIf="showChart" (click)="showChart = false">{{ 'COMMISSIONS.SHOW_TABLE' | translate }}</button>
          </div>
        </div>
      </div>
      <div class="card-body pt-0 overflow-x-hidden" *ngIf="showChart">
        <div *ngIf="balance.value.length > 0">
          <div class="chart" *ngFor="let data of chartData; let first = first" [ngClass]="{'border-top pt-2': !first}">
            <h2 *ngIf="chartData.length > 1" class="cursor-pointer d-flex" [ngClass]="{'pt-1': first}" (click)="toggleOpenedYear(data.year)">
              <div *ngIf="yearIsOpen(data.year)">
                <i data-feather="minus" size="16"></i>
              </div>
              <div *ngIf="!yearIsOpen(data.year)">
                <i data-feather="plus" size="16"></i>
              </div>
              <div class="ml-05">{{ data.year }}</div>
            </h2>
            <div class="pt-1">
              <apx-chart *ngIf="yearIsOpen(data.year)" [series]="data.series" [chart]="chartOptions.chart" [stroke]="chartOptions.stroke" [dataLabels]="chartOptions.dataLabels" [plotOptions]="chartOptions.plotOptions"
                         [xaxis]="chartOptions.xaxis" [colors]="chartOptions.colors" [fill]="chartOptions.fill" [yaxis]="chartOptions.yaxis" [legend]="chartOptions.legend"></apx-chart>
            </div>
          </div>
        </div>
        <p *ngIf="balance.value.length < 1">{{ 'NO_DATA_TO_DISPLAY' | translate }}</p>
      </div>
      <div class="card-body p-0 overflow-hidden" *ngIf="!showChart" [ngClass]="{'pb-2': balance.value.length < 1}">
        <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="30" [scrollbarH]="true" [rowHeight]="_utilService.isDesktop ? 60 : 350" [limit]="999"
                       [footerHeight]="0" [rows]="balance.value" [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }">
          <ngx-datatable-column [name]="'MONTH_YEAR' | translate" prop="month" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ monthsList[row.month - 1] }} {{ row.year }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'TOTAL_PROFIT_PERTINENT' | translate" prop="total_profit" [width]="200" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <strong>{{ row.total_profit | currency: 'EUR' }}</strong>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'TOTAL_RESIDUE_PROFIT_PERTINENT' | translate" prop="total_profit" [width]="200" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <strong [ngbTooltip]="'TOTAL_RESIDUE_PROFIT_PERTINENT' | translate">{{ row.total_residue_profit | currency: 'EUR' }}</strong>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'TOTAL_COST' | translate" prop="total_cost" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <strong>{{ row.total_cost | currency: 'EUR' }}</strong>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'TOTAL_COMMISSION_REAL_COST' | translate" prop="total_commission_real_cost" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.total_commission_real_cost | currency: 'EUR' }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'TOTAL_PROVIDER_COST' | translate" prop="total_provider_cost" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.total_provider_cost | currency: 'EUR' }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'TOTAL_STRUCTURE_COST' | translate" prop="total_structure_cost" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.total_structure_cost | currency: 'EUR' }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'EURO_MARGIN' | translate" prop="margin_currency" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <strong>{{ row.margin_currency | currency: 'EUR' }}</strong>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'PERCENTAGE_MARGIN' | translate" prop="total_structure_cost" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <strong>{{ row.margin_percentage }}%</strong>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
        <ngx-datatable class="border-top pb-0" [style.background-color]="'#F3F2F7'" columnMode="force" [headerHeight]="0" [scrollbarH]="true" [rowHeight]="50" [rows]="[total_row]" [limit]="1"
                       [sorts]="[{ prop: 'year', dir: 'desc' }, { prop: 'month', dir: 'desc' }]" [footerHeight]="0" *ngIf="_utilService.isDesktop && balance.value.length > 0">
          <ngx-datatable-column [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
              <strong>{{ 'TOTAL' | translate }}</strong>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [sortable]="false" [width]="190">
            <ng-template ngx-datatable-cell-template let-row="row">
              <strong [style.margin-left.px]="-10" class="d-block">{{ row.total_profit | currency: 'EUR' }}</strong>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [sortable]="false" [width]="200">
            <ng-template ngx-datatable-cell-template let-row="row">
              <strong class="d-block" [style.margin-left.px]="-7">{{ row.total_residue_profit | currency: 'EUR' }}</strong>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
              <strong class="d-block" [style.margin-left.px]="-7">{{ row.total_cost | currency: 'EUR' }}</strong>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
              <strong class="d-block" [style.margin-left.px]="-7">{{ row.total_commission_real_cost | currency: 'EUR' }}</strong>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
              <strong class="d-block" [style.margin-left.px]="-7">{{ row.total_provider_cost | currency: 'EUR' }}</strong>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
              <strong class="d-block" [style.margin-left.px]="-7">{{ row.total_structure_cost | currency: 'EUR' }}</strong>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
              <strong class="d-block" [style.margin-left.px]="-7">{{ row.margin_currency | currency: 'EUR' }}</strong>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
              <strong class="d-block" [style.margin-left.px]="-7">{{ row.margin_percentage }}%</strong>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>